import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["inputProps", "name", "label", "validate"];
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { useField } from 'react-final-form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function FFToggle(_ref) {
  let {
      inputProps = {},
      name,
      label,
      validate = () => {}
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    input,
    meta
  } = useField(name, {
    validate,
    type: 'checkbox'
  });
  return /*#__PURE__*/_jsx(FormControl, Object.assign({}, rest, {
    error: meta.touched && meta.error,
    validationMessage: meta.touched && meta.error,
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "row",
      gap: "1200",
      justifyContent: "space-between",
      children: [label && /*#__PURE__*/_jsx(Text, {
        children: label
      }), /*#__PURE__*/_jsx(Toggle, Object.assign({}, input, inputProps))]
    })
  }));
}